const Currency = [
  { value: 'in', name: 'INR' },
  { value: 'us', name: 'USD' },
  { value: 'np', name: 'NPR' },
  { value: 'au', name: 'AUD' },
  { value: 'sg', name: 'SGD' },
  { value: 'global', name: 'USD' },
  { value: 'my', name: 'MYR' },
  { value: 'ca', name: 'CAD' },
  { value: 'gr', name: 'EUR' },
  { value: 'uk', name: 'GBP' },
];
export default Currency;
